exports = module.exports = require("../../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LabelFormData .items{margin-bottom:20px;display:flex;flex-direction:column}.LabelFormData .items .item+.item{margin-top:10px}.LabelFormData .items .item{display:flex;flex-direction:row}.LabelFormData .items .item .label-item{position:relative;display:flex;align-items:center;cursor:pointer;flex:auto;background:#61bd4f;color:#fff;padding:5px 10px;border-radius:3px;margin-right:10px}.LabelFormData .items .item .label-item .icon{right:10px;position:absolute}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionForm/components/Labels/components/FormData/style.scss
// module id = 2589
// module chunks = 0